<template>
  <div style="height:100%;width:100%;overflow-x:hidden;background-color: #F1F3F5" id="home">
<!--    <div id="box" ref="box" v-show="BoardInfoShowIs==1">
      <div class="marquee-box" ref="marquee" @mouseover="menter" @mouseleave="mleave" >
        <p ref="cmdlist" id="pWidth">
          <img style="width: 15px;height: 15px" src="@/assets/images/bg40.png" alt="">{{ BoardInfoShow }}
        </p>
      </div>
    </div>-->
    <div style="width:100%;height:80px;">
      <div  class="top" style="width:100%;height:80px;background: linear-gradient(to right, #E6F0FA, #2584FE);">
        <el-button icon="el-icon-s-fold" style="height: 78px;width: 78px;" @click="toggle()"></el-button>
        <a v-if="isXl"  class="logo"><img style="height: 70px;margin-top: -5px" src="@/assets/images/xinlanlogo.png"  @click="goTo('')" /></a>
        <a v-else-if="Isqek"  class="logo"><img style="height: 70px;margin-top: -5px" src="@/assets/images/logo2.png"  @click="goTo('')" /></a>
        <a v-else-if="islnj"  class="logo"></a>
        <a v-else  class="logo"><img src="@/assets/images/logo.png"  @click="goTo('')" /></a>
        <ul class="top_ul">
          <li class="nav_more">
                <a href="#" style="width:90px;" class="shezhi"><img src="@/assets/images/bg25.png" /></a>
                      <ul class="list_ol">
                        <li v-if="isAdmin"><a :href="$prefix + '#/largeScreen'">{{$t('homepage.bigDataBulletinBoard')}}</a></li>
<!--                        <li v-if="isAdmin"><a href="javascript:void(0)" @click="goToLargeScreen">{{$t('homepage.bigDataBulletinBoard')}}</a></li>-->
                        <li><a href="#" @click="goTo('Person')">{{$t('home.setting')}}</a></li>
                        <li><a href="#" @click="noticedialog">{{$t('home.notice')}}</a></li>
                        <li><a href="#" @click.prevent="logOut">{{$t('home.logOut')}}</a></li>
                      </ul>
              </li>
        </ul>
        <a href="#" @click="goTo('Person')" class="admin"><img src="@/assets/images/bg39.png" /><span style="color: #ffffff !important;">{{UserTitle}}，{{$t('homepage.welcome')}}</span></a>
        <el-switch
          v-model="currentLang"
          active-text="English"
          active-color="#474747"
          inactive-text="中文"
          inactive-color="#F25C01"
          active-value="en"
          inactive-value="zh"
          @change="changeLang">
        </el-switch>
      </div>
    </div>
    <div :class="$i18n.locale == 'en'?'hello englishText':'hello chineseText'" style="height:calc(100% - 80px);width: 100%;overflow:hidden">
      <div style="height:100%;position:fixed;left:0;width:200px;">
        <el-menu
          style="height:100%;text-align:left;width:100%;"
          default-active="homepage"
          class="el-menu-vertical-demo"
          background-color="#E6F0FA"
          text-color="#666666"
          active-text-color="#1478FE"

          @select="handleSelect"
          :collapse="isCollapse"
          :collapse-transition="true"
          :unique-opened="true"
          >

          <el-menu-item index="homepage" id="homepage" >
            <i class="el-icon-menu"></i>
            <span slot="title" class="custom-menu-item">{{$t('home.homePage')}}</span>
          </el-menu-item>
          <el-submenu index="3" v-if="Auth.equip || Auth.malfunction" >
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span >{{$t('home.equipmentManagement')}}</span>
            </template>
              <el-menu-item index="equipmentmanagement" id="equipmentmanagement" v-if="Auth.equip">{{$t('home.equipmentList')}}</el-menu-item>
              <el-menu-item index="equipmentinspection" id="equipmentinspection" v-if="Auth.equipinspect">{{$t('home.equipmentQualityInspection')}}</el-menu-item>
              <el-menu-item index="usermanagement" id="usermanagement" v-if="Auth.usermanage">{{$t('home.assignEquipment')}}</el-menu-item>
              <el-menu-item index="malfunctionmanage" id="malfunctionmanage" v-if="Auth.malfunction">{{$t('home.faultList')}}</el-menu-item>
              <el-menu-item index="washRecords" id="washRecords" v-if="Auth.washRecords">{{$t('home.washrecords')}}</el-menu-item>
              <el-menu-item index="calibrationRecords" id="calibrationRecords" v-if="Auth.calibrationRecord">{{$t('home.calibrationRecords')}}</el-menu-item>
              <el-menu-item index="rawAttention" id="rawAttention" v-if="Auth.rawAttention">原料预警提醒</el-menu-item>
              <el-menu-item index="video-maintain" id="video-maintain" v-if="Auth.videoMaintain">视频维护</el-menu-item>
          </el-submenu>
          <el-submenu index="4" v-if="Auth.loggin || Auth.usermanage || Auth.pay">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>{{$t('home.accountManagement')}}</span>
            </template>
              <el-menu-item index="logginaccount" id="logginaccount" v-if="Auth.loggin">{{$t('home.loginAccount')}}</el-menu-item>
<!--              <el-menu-item index="WechatGroup">运维用户组</el-menu-item>-->
              <el-menu-item index="payconfig" id="payconfig" v-if="Auth.pay">{{$t('home.paymentConfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuAppConfig" id="HuiFuAppConfig" v-if="isAdmin">{{$t('homepage.huifuappconfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuMemberConfig" id="HuiFuMemberConfig" v-if="isAdmin">{{$t('homepage.huifuuserconfiguration')}}</el-menu-item>
              <el-menu-item index="HuiFuPaymentConfig" id="HuiFuPaymentConfig" v-if="isAdmin">{{$t('homepage.huifupayconfiguration')}}</el-menu-item>
          </el-submenu>
          <el-submenu index="5" v-if="(Auth.beverage || Auth.beverageanr || Auth.speed || Auth.rawmater)&&!isAdmin">
            <template slot="title">
              <i class="el-icon-coffee"></i>
              <span>{{$t('home.beverageManagement')}}</span>
            </template>
              <el-menu-item index="surongbeveragemanage" id="surongbeveragemanage" v-if="Auth.surongbeverage">{{$t('home.nbbg2RecipeLibrary')}}</el-menu-item>
              <el-menu-item index="xianmobeveragemanage" id="xianmobeveragemanage" v-if="Auth.xianmobeverage">{{$t('home.newCombiRecipeLibrary')}}</el-menu-item>
              <el-menu-item index="beveragearrange" id="beveragearrange" v-if="Auth.beverageanr">{{$t('home.recipeLibraryAssignment')}}</el-menu-item>
              <el-menu-item index="e3sbeveragemanage" id="e3sbeveragemanage" v-if="Auth.xianmobeverage">E3S配方库</el-menu-item>
              <el-menu-item index="e3sbeveragearrange" id="e3sbeveragearrange" v-if="Auth.beverageanr">E3S配方库分配</el-menu-item>
              <el-submenu index="1-4">
                <template slot="title">雀巢双机</template>
                <el-menu-item index="SHC430Manage">SHC430配方库</el-menu-item>
                <el-menu-item index="SHC430Arrange">SHC430配方库分配</el-menu-item>
                <el-menu-item index="LHC330Manage">LHC330配方库</el-menu-item>
                <el-menu-item index="LHC330Arrange">LHC330配方库分配</el-menu-item>
              </el-submenu>
          </el-submenu>
          <el-submenu index="6" v-if="Auth.standardcon || Auth.userlevel">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>{{$t('home.standardDataConfiguration')}}</span>
            </template>
              <el-menu-item index="equiptypeconfig" id="equiptypeconfig" v-if="Auth.equiptypecon">{{$t('home.equipmentTypeConfiguration')}}</el-menu-item>
              <el-menu-item index="standardconfig" id="standardconfig" v-if="Auth.standardcon">{{$t('home.salesChannelConfiguration')}}</el-menu-item>
              <el-menu-item index="userlevelconfig" id="userlevelconfig" v-if="Auth.userlevel">{{$t('home.userLevelConfiguration')}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="saledata" id="saledata" v-if="Auth.sale">
            <i class="el-icon-s-data"></i>
            <span slot="title">{{$t('home.salesDataStatistics')}}</span>
          </el-menu-item>
          <el-submenu index="yonghecuptype" id="yonghecuptype" v-if="Auth.yh">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>永和配方库</span>
            </template>
            <el-menu-item index="yh-cupSize" id="yh-cupSize" v-if="Auth.yh_cupSize">杯型尺寸管理</el-menu-item>
            <el-menu-item index="yh-group" id="yh-group" v-if="Auth.yh_group">配方分组管理</el-menu-item>
            <el-menu-item index="yh-rawMaterial" id="yh-rawMaterial" v-if="Auth.yh_rawMaterial">原料管理</el-menu-item>
            <el-menu-item index="yh-resetCache" id="yh-resetCache" v-if="Auth.yh_resetCache">重置缓存</el-menu-item>
            <el-submenu index="df31" id="df31">
              <template slot="title">东风31</template>

              <el-menu-item index="yh-formula" id="yh-formula" v-if="Auth.yh_formula">配方管理</el-menu-item>
              <el-menu-item index="yh-assign" id="yh-assign" v-if="Auth.yh_assign">分配配方</el-menu-item>
              <el-menu-item index="yh-template" id="yh-template" v-if="Auth.yh_template">模板管理</el-menu-item>
            </el-submenu>

            <el-submenu index="ai-juice" id="ai-juice">
              <template slot="title">AI果汁机</template>
              <el-menu-item index="yh-formula-ai" id="yh-formula-ai" v-if="Auth.yh_rawMaterial">配方管理</el-menu-item>
              <el-menu-item index="yh-assign-ai" id="yh-assign" v-if="Auth.yh_assign">分配配方</el-menu-item>
            </el-submenu>
          </el-submenu>
<!--          <el-submenu index="5">-->
<!--            <template slot="title">-->
<!--              <i class="el-icon-s-tools"></i>-->
<!--              <span>{{$t('home.salesDataStatistics')}}</span>-->
<!--            </template>-->
<!--            <el-menu-item index="saledata" id="saledata" v-if="Auth.sale">-->
<!--              <i class="el-icon-s-data"></i>-->
<!--              <span slot="title">{{$t('home.salesDataStatistics')}}</span>-->
<!--            </el-menu-item>-->
<!--            <el-menu-item index="formeryearssaledata" id="formeryearssaledata" v-if="Auth.sale">-->
<!--              <i class="el-icon-s-data"></i>-->
<!--              <span slot="title">往年销售数据</span>-->
<!--            </el-menu-item>-->
<!--          </el-submenu>-->
          <el-menu-item index="remotecontrol" id="remotecontrol" v-if="Auth.remote">
            <i class="el-icon-link"></i>
            <span slot="title">{{$t('home.remoteControl')}}</span>
          </el-menu-item>
          <el-submenu index="miniProgram" v-if="isAdmin || Auth.miniuser">
            <template slot="title">
              <i class="el-icon-s-ticket"></i>
              <span>{{$t('home.applet')}}</span>
            </template>
            <el-menu-item index="miniuser" id="miniuser" v-if="isAdmin || Auth.miniuser">{{$t('home.appletmember')}}</el-menu-item>
            <el-menu-item index="promotions" id="promotions" v-if="isAdmin || Auth.promotions"><span slot="title">{{$t('home.coupon')}}</span></el-menu-item>
            <el-menu-item index="rechargeStrategy" id="rechargeStrategy" v-if="isAdmin || Auth.rechargestrategy"><span slot="title">{{$t('home.Rechargestr')}}</span></el-menu-item>
            <el-menu-item index="newEmployeeBenefits" id="newEmployeeBenefits" v-if="isAdmin || Auth.rechargestrategy"><span slot="title">{{$t('home.Newbenefits')}}</span></el-menu-item>
            <el-menu-item index="signInBenefits" id="signInBenefits" v-if="isAdmin || Auth.rechargestrategy"><span slot="title">{{$t('home.Sginbenefits')}}</span></el-menu-item>
          </el-submenu>
          <el-menu-item index="operatelog" id="operatelog" v-if="Auth.operate">
            <i class="el-icon-s-order"></i>
            <span slot="title">{{$t('operatelog.operationLog')}}</span>
          </el-menu-item>
          <el-menu-item index="trafficwarning" id="trafficwarning" v-if="Auth.traffic">
            <i class="el-icon-warning-outline"></i>
            <span slot="title">{{$t('home.flowEarlyWarning')}}</span>
          </el-menu-item>
          <el-menu-item index="myduty" id="myduty" v-if="Auth.myduty">
            <i class="el-icon-s-claim"></i>
            <span slot="title">{{$t('home.myTask')}}</span>
          </el-menu-item>
          <el-submenu index="1" v-if="Auth.formulamanage || Auth.formulaclass||Auth.cupteamachinemanagement" >
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span slot="title">{{$t('home.teaCupManagement')}}</span>
            </template>
            <el-menu-item index="formulamanage" id="formulamanage" >{{$t('home.formulamanage')}}</el-menu-item>
            <el-menu-item index="formulaclass" id="formulaclass" >{{$t('home.formulaclass3S')}}</el-menu-item>
            <el-menu-item index="cupteamachinemanagement" id="cupteamachinemanagement" >{{$t('home.cupteamachinemanagement')}}</el-menu-item>
          </el-submenu>
          <el-submenu index="2" v-if="Auth.milkseriomanage || Auth.milkclass||Auth.milkteamachinemanagement" >
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>{{$t('home.milkteaCupManagement')}}</span>
            </template>
            <el-menu-item index="milkseriomanage" id="milkseriomanage" >{{$t('home.milkseriomanage')}}</el-menu-item>
            <el-menu-item index="milkclass" id="milkclass" >{{$t('home.milkclass')}}</el-menu-item>
            <el-menu-item index="milkteamachinemanagement" id="milkteamachinemanagement" >{{$t('home.milkteamachinemanagement')}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="UpdateRecord" id="UpdateRecord">
            <i class="el-icon-s-claim"></i>
            <span slot="title">更新记录</span>
          </el-menu-item>
        </el-menu>
      </div>
      <!--查看奶茶配方已分配-->
      <el-dialog
        title="公告栏"
        :visible.sync="IotNoticeVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        width="65%"
        :append-to-body="true"
      >
        <el-card  style="padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
          <el-row :gutter="24" class="row">
            <el-col :span="24">
              <el-table
                :data="Boardtable"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="公告内容：">
                        <span>{{ props.row.boardInfo }}</span>
                      </el-form-item>
                      <el-form-item label="创建时间：">
                        <span>{{ props.row.createdOn }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  type="index"
                  :label="$t('serialNo')"
                  width="100px"
                >
                </el-table-column>
                <el-table-column
                  label="公告内容"
                  prop="boardInfo">
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  prop="createdOn">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="margin-top:2%;text-align:right">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[10, 20,50,100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalBoardCount">
              </el-pagination>
            </el-col>
          </el-row>
        </el-card>

      </el-dialog>
      <!--内容区域-->
      <div :style="contentStyle">
        <el-tabs v-if=!this.IsHomepage  v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="handleTabClick" style="margin:15px 10px -15px 0px">
          <el-tab-pane
            v-for="(item, index) in tabs"
            :key="index"
            :label="$i18n.locale =='zh'?item.title:item.englishTitle"
            :name="item.index"
            >
          </el-tab-pane>
        </el-tabs>
        <!--这里是路由加载进来的页面-->
        <router-view  style="height:100%;overflow:hidden;"/>
      </div>
    </div>
  </div>

</template>

<script>
import EquipmentManagement from '@/pages/equipmentmanagement/equipmentmanagement'
export default {
  name: 'home',
  data () {
    return {
      BoardInfoShowIs:0,
      BoardInfoShow:"",
      totalBoardCount:0,
      currentPage4:1,
      Boardtable: [],
      pageSize:10,
      pageIndex:1,
      noticetable: [],
      IotNoticeVisible: false,
      value: 0,
      timer: '',//计时器
      pwidth:0,//公告文本的宽度
      windowWidth:document.documentElement.clientWidth,// 设备屏幕的宽度
      IsHomepage:false,
      isCollapse:false,
      dateKey:new Date,
      saleList:[],
      saleRankList:[],
      UserTitle:"",
      contentStyle:{
        background:"#fff",
        height:"100%",
        position:"relative",
        transition:'all .5s',
        'margin-right':"3px",
        'margin-left':"210px"
      },
      selected:'homepage',
      tabs: [
      ],
      editableTabsValue: 'homepage',
      routerConfigs:[
        {index:"homepage",title:"首页",englishTitle:'homePage'},
        {index:"equipmentmanagement",title:"设备列表",englishTitle:'equipment list'},
        {index:"equipmentinspection",title:"设备质检",englishTitle:'equipment quality inspection'},
        {index:"malfunctionmanage",title:"故障列表",englishTitle:'fault list'},
        {index:"logginaccount",title:"登录账号",englishTitle:'login account'},
        //{index:"WechatGroup",title:"运维用户组",englishTitle:'Wechat Group'},
        {index:"usermanagement",title:"分配设备",englishTitle:'assign equipment'},
        {index:"payconfig",title:"收款配置",englishTitle:'payment configuration'},
        {index:"HuiFuAppConfig",title: "汇付应用配置",englishTitle: 'huifuapp configuration'},
        {index:"HuiFuPaymentConfig",title: "汇付收款配置",englishTitle: 'huifu configuration'},
        {index:"HuiFuMemberConfig",title: "汇付用户配置",englishTitle: 'huifu member configuration'},
        {index:"xianmobeveragemanage",title:"New Combi配方库",englishTitle:'new combi recipe library'},
        {index:"surongbeveragemanage",title:"NBBG2配方库",englishTitle:'nbbg2 recipe library'},
        {index:"e3sbeveragemanage",title:"E3S配方库",englishTitle:'E3S recipe library'},

        // 永和系列功能
        {index:"yh-rawMaterial",title:"永和原料管理",englishTitle:'YongHe raw material'},
        {index:"yh-cupSize",title:"杯型尺寸管理",englishTitle:'YongHe raw material'},
        {index:"yh-group",title:"分组管理",englishTitle:'YongHe raw material'},
        {index:"yh-formula",title:"配方管理",englishTitle:'YongHe raw material'},
        {index:"yh-cupType",title:"杯型管理",englishTitle:'YongHe raw material'},
        {index:"yh-template",title: "模板管理",englishTitle: 'YongHe template'},
        {index:"yh-assign",title: "配方分配",englishTitle: 'YongHe assign'},
        {index:"yh-resetCache",title:"重置缓存",englishTitle: "Reset cache"},
        {index:"yh-rawMaterial-ai",title:"永和原料管理",englishTitle: "YongHe raw material"},
        {index:"yh-formula-ai",title:"配方管理",englishTitle:'YongHe raw material'},
        {index:"yh-assign-ai",title: "配方分配",englishTitle: 'YongHe assign'},

        {index:"NestRawMaterial",title:"原料管理",englishTitle:'Nest RawMaterial'},
        {index:"SHC430Manage",title:"SHC430配方",englishTitle:'SHC430 Manage'},
        {index:"SHC430Arrange",title:"SHC430分配",englishTitle:'SHC430 Arrange'},
        {index:"LHC330Manage",title:"LHC330配方",englishTitle:'LHC330 Manage'},
        {index:"LHC330Arrange",title:"LHC330分配",englishTitle:'LHC330 Arrange'},
        {index:"beveragearrange",title:"配方库分配",englishTitle:'recipe library assignment'},
        {index:"e3sbeveragearrange",title:"E3S配方库分配",englishTitle:'E3S recipe library assignment'},
        {index:"speeddelay",title:"速率延迟",englishTitle:'assign equipment'},
        {index:"rawmaterial",title:"原料库管理",englishTitle:'assign equipment'},
        {index:"equiptypeconfig",title:"设备类型配置",englishTitle:'assign equipment'},
        {index:"standardconfig",title:"销售渠道配置",englishTitle:'sales channel configuration'},
        {index:"userlevelconfig",title:"用户层级配置",englishTitle:'user level configuration'},
        {index:"saledata",title:"销售数据统计",englishTitle:'sales data statistics'},
        {index:"formeryearssaledata",title:"往年销售数据",englishTitle:'former years sales data statistics'},
        {index:"remotecontrol",title:"远程控制",englishTitle:'remote control'},
        {index:"operatelog",title:"操作日志",englishTitle:'operation log'},
        {index:"trafficwarning",title:"流量预警",englishTitle:'flow early warning'},
        {index:"myduty",title:"我的任务",englishTitle:'my task'},
        {index:"personalcenter",title:"个人中心",englishTitle:'assign equipment'},
        {index:"Person",title:"个人信息",englishTitle:'person center'},
        {index:"UpdateRecord",title:"更新记录",englishTitle:'update record'},
        {index:"miniuser",title:'小程序会员',englishTitle:'assign equipment'},
        {index:"promotions",title:'优惠券',englishTitle:'assign equipment'},
        {index:"rechargeStrategy",title:"充值策略",englishTitle:'assign equipment'},
        {index:"newEmployeeBenefits",title:"新人福利",englishTitle:'benefits'},
        {index:"signInBenefits",title:"签到福利",englishTitle:'sign in benefits'},
        {index:'washRecords',title:'清洗记录',englishTitle: 'washRecords'},
        {index:'calibrationRecords',title:'校准记录',englishTitle: 'CalibrationRecords'},
        {index:'formulaclass',title:'萃茶机3S配方管理',englishTitle: 'formulaclass'},
        {index:'formulamanage',title:'萃茶机S配方管理',englishTitle: 'formulamanage'},
        {index:'cupteamachinemanagement',title:'机台管理',englishTitle: 'cupteamachinemanagement'},
        {index:'milkclass',title:'奶茶配方',englishTitle: 'milkclass'},
        {index:'milkseriomanage',title:'奶茶配方管理',englishTitle: 'milkseriomanage'},
        {index:'milkteamachinemanagement',title:'奶茶机管理',englishTitle: 'milkteamachinemanagement'},
        {index:'video-maintain',title:'视频维护',englishTitle: 'videoMaintain'},

        {index:'rawAttention',title:'原料预警提醒',englishTitle: 'raw material attention'}
      ],
      menuTrees: new Object(),
      isAdmin:false,
      Auth:[{
        equip:false,
        equipinspect:false,
        malfunction:false,
        loggin:false,
        usermanage:false,
        pay:false,
        xianmobeverage:false,
        surongbeverage:false,
        beverageanr:false,
        speed:false,
        rawmater:false,
        equiptypecon:false,
        standardcon:false,
        userlevel:false,
        sale:false,
        remote:false,
        promo:false,
        operate:false,
        traffic:false,
        myduty:false,
        miniuser:false,
        promotions:false,
        rechargestrategy:false,
        formulaclass:false,
        formulamanage:false,
        cupteamachinemanagement:false,
        milkseriomanage:false,
        milkclass:false,
        milkteamachinemanagement:false,
        UpdateRecord:false,
        yh:false,
        yh_cupSize:false,
        yh_group:false,
        yh_rawMaterial:false,
        yh_formula:false,
        yh_assign:false,
        yh_template:false,
        yh_resetCache:false
      }],
      currentLang:'zh',// 当前语言
      Isqek:false,
      isXl:false,// 是否是新蓝定制登录
      islnj:false,// 是否是老娘舅定制登录
    }
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  watch: {
/*    value(newValue, oldValue) {
      let allWidth= parseInt(1.8*this.windowWidth)+parseInt(this.pwidth[0]);
      if(newValue <= -allWidth){
        this.$refs.cmdlist.style.marginLeft = this.windowWidth+"px";
        this.value = 0;
      }
    },*/
    $route(to, from){
      // todo
      let tab = new Object();
      let arrayPath = to.path.split('/');
      let index = arrayPath[arrayPath.length-1];
      tab.index = index;
      tab.path = "/home/"+index;
      let routerConfig = this.routerConfigs.find(x=>x.index==index);
      if(routerConfig){
        tab.title = routerConfig.title;
        tab.englishTitle = routerConfig.englishTitle
      }
      if(this.tabs.filter(x=>x.index==index).length==0){
        this.tabs.push(tab);
      }
      this.editableTabsValue = index;
      //this.logFullRoute(to);
    }
  },
  mounted(){
      //console.log("被刷新",this.$account.data)
    //查看用户是否登录
    if(this.$account.data){
      this.isAdmin = this.$account.data.isAdmin;
      this.UserTitle = this.$account.data.accountName;
      let token = this.$cookies.get("token");
      let flag = sessionStorage.getItem("loginFlag")
      if(flag === "1"){
          this.Isqek = true
      }else if(flag === "2"){
          this.isXl = true
      }else if(flag === "3"){
          this.islnj = true
      }else {

      }
      if(!token){
        if (this.Isqek){
          this.$router.push("/loginqek");
        }else if(this.isXl){
          this.$router.push("/loginXl")
        }else if(this.islnj){
          this.$router.push("/loginlnj")
        }else{
          this.$router.push("/login");
        }
      }else{
        //获取用户信息
        let that = this;
        let tokenStr = "Bearer "+token;
        this.$httpservice.get("api/account/currentaccount",{},{Authorization:tokenStr} ).then(
            function (data) {
                if(data.body.code=="200"){
                    that.$account.data = data.body.data;
                    that.UserTitle = data.body.data.accountName;
                    that.menuTrees = data.body.data.menuTrees;

                    that.menuTrees.forEach((item, index) => {
                        switch(item.code){
                          case 'equipmentmanagement':
                            that.Auth.equip = true;
                            break
                          case 'equipmentinspection':
                            that.Auth.equipinspect = true;
                            break
                          case 'malfunctionmanage':
                            that.Auth.malfunction = true;
                            break
                          case 'logginaccount':
                            that.Auth.loggin = true;
                            break
                          case 'usermanagement':
                            that.Auth.usermanage = true;
                            break
                          case 'payconfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuAppConfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuPaymentConfig':
                            that.Auth.pay = true;
                            break
                          case 'HuiFuMemberConfig':
                            that.Auth.pay = true;
                            break
                          case 'surongbeveragemanage':
                            that.Auth.surongbeverage = true;
                            break
                          case 'xianmobeveragemanage':
                            that.Auth.xianmobeverage = true;
                            break
                          case 'beveragearrange':
                            that.Auth.beverageanr = true;
                            break
                          case 'speeddelay':
                            that.Auth.speed = true;
                            break
                          case 'rawmaterial':
                            that.Auth.rawmater = true;
                            break
                          case 'equiptypeconfig':
                            that.Auth.equiptypecon = true;
                            break
                          case 'standardconfig':
                            that.Auth.standardcon = true;
                            break
                          case 'userlevelconfig':
                            that.Auth.userlevel = true;
                            break
                          case 'saledata':
                            that.Auth.sale = true;
                            break
                          case 'remotecontrol':
                            that.Auth.remote = true;
                            break
                          case 'operatelog':
                            that.Auth.operate = true;
                            break
                          case 'trafficwarning':
                            that.Auth.traffic = true;
                            break
                          case 'myduty':
                            that.Auth.myduty = true;
                            break
                          case 'miniuser':
                            that.Auth.miniuser = true;
                            break
                          case 'promotions':
                            that.Auth.promotions = true;
                            break
                          case 'rechargestrategy':
                            that.Auth.rechargestrategy = true;
                            break
                          case 'washRecords':
                            that.Auth.washRecords = true;
                            break
                          case 'calibrationRecords':
                            that.Auth.calibrationRecord = true;
                            break
                          case 'formulaclass':
                            that.Auth.formulaclass = true;
                            break
                          case 'formulamanage':
                            that.Auth.formulamanage = true;
                            break
                          case 'cupteamachinemanagement':
                            that.Auth.cupteamachinemanagement = true;
                            break
                          case 'milkclass':
                            that.Auth.milkclass = true;
                            break
                          case 'milkseriomanage':
                            that.Auth.milkseriomanage = true;
                            break
                          case 'milkteamachinemanagement':
                            that.Auth.milkteamachinemanagement = true;
                            break
                          case 'yh-cupSize':
                            that.Auth.yh = true
                            that.Auth.yh_cupSize = true;
                            break;
                          case 'yh-group':
                            that.Auth.yh = true
                            that.Auth.yh_group = true;
                            break;
                          case 'yh-rawMaterial':
                            that.Auth.yh = true
                            that.Auth.yh_rawMaterial = true;
                            break;
                          case 'yh-formula':
                            that.Auth.yh = true
                            that.Auth.yh_formula = true;
                            break;
                          case 'yh-assign':
                            that.Auth.yh = true
                            that.Auth.yh_assign = true;
                            break;
                          case 'yh-template':
                            that.Auth.yh = true
                            that.Auth.yh_template = true;
                            break;
                          case 'yh-resetCache':
                            that.Auth.yh = true
                            that.Auth.yh_resetCache = true;
                            break;
                          case 'video-maintain':
                            that.Auth.videoMaintain = true;
                            break;
                          case 'rawAttention':
                            that.Auth.rawAttention = true;
                            break;
                        }
                    })
                    that.$forceUpdate();
                }else{
                    that.$message({
                        message: data.body.msg,
                        type: 'danger'
                    });
                  if (this.Isqek){
                    this.$router.push("/loginqek")
                  }else if(this.isXl){
                    this.$router.push("/loginXl")
                  }else if(this.islnj){
                    this.$router.push("/loginlnj")
                  }else {
                    this.$router.push("/login");
                  }
                }
            },
            function (data) {
                let statusCode = data.status;
                that.$message({
                    message: that.$t('queryFailedStatusCode')+statusCode,
                    type: 'warning'
                });
              if (this.Isqek){
                this.$router.push("/loginqek");
              }else if(this.isXl){
                this.$router.push("/loginXl")
              }else if(this.islnj){
                this.$router.push("/loginlnj")
              }else {
                this.$router.push("/login");
              }
            }
        );
      }
    }else{
      window.location.href="/";
    }

    this.initTabs();
    let temp = localStorage.getItem('languageSet')
    if(temp){
      this.currentLang = temp
    }else{
      this.currentLang = 'zh'
    }
  },
  methods:{
    handleSizeChange(e){
      this.pageSize=e;
      this.currentPage4 = 1
      this.loadMilkEquipList(1)
    },
    handleCurrentChange(e){
      this.currentPage4 = e
      this.loadMilkEquipList(e)
    },
    noticedialog(){
      this.IotNoticeVisible=true;
    },
/*    clickCommend(e) {
      let _this = this;
      this.$nextTick(() => {
        this.value -=1;
        this.$refs.cmdlist.style.marginLeft = _this.windowWidth+this.value+"px"
      });
    },*/
/*    menter(){
      clearInterval(this.timer);
    },*/
/*    mleave(){
      this.timer = setInterval(this.clickCommend, 10);
    },*/
    logFullRoute(route) {
      console.log('Full route information:', this.getFullRoute());
    },
    getFullRoute() {
      const fullUrl = window.location.href;
      const routeInfo = {
        fullUrl: fullUrl,
        path: this.$route.path,
        name: this.$route.name,
        params: this.$route.params,
        query: this.$route.query,
        hash: this.$route.hash,
        fullPath: this.$route.fullPath,
        matched: this.$route.matched
      };
      return routeInfo;
    },
    initTabs(){
      //初始化选项卡
      let arrayStr = window.location.href.split('/');
      let pageString = arrayStr[arrayStr.length-1];
      let routerConfig = this.routerConfigs.find(x=>x.index==pageString);
      if(routerConfig){
        let tab = { path: "/home/"+pageString, index: pageString, title: routerConfig.title,englishTitle:routerConfig.englishTitle};
        this.tabs.push(tab);
        this.editableTabsValue = pageString;
        if (tab.path.includes("homepage")) {
          this.IsHomepage=true;
        } else {
          this.IsHomepage=false;
        }
        this.$router.push("/home/"+pageString);
      }else{
        let tab = { path: "/home/homepage", index: "homepage", title: "首页",englishTitle:'home page' };
        this.tabs.push(tab);
        this.editableTabsValue = "homepage";
        if (tab.path.includes("homepage")) {
          this.IsHomepage=true;
        } else {
          this.IsHomepage=false;
        }
      }
    },
    handleTabClick(tab, event) {
      this.$router.push("/home/"+tab.name);
      if(tab.name=="homepage")
      {
        this.IsHomepage=true;
      }
      else
      {
        this.IsHomepage=false;
      }
    },
    removeTab(targetName){
      if(this.tabs.length==1){
        return;
      }

      let activeName = this.editableTabsValue;
      //如果关闭的是当前的选项卡
      if (activeName === targetName) {
        this.tabs.forEach((tab, index) => {
          if (tab.index === targetName) {
            //找到当前关闭的选项卡（即当前选项卡）的左边的或者右边的
            let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.index;
              this.$router.push("/home/"+nextTab.index);
            }

          }
        });
        if (activeName=="homepage")
        {
          this.IsHomepage=false;
        }
      }
      //选中
      this.editableTabsValue = activeName;
      //删除操作
      this.tabs = this.tabs.filter(tab => tab.index !== targetName);
    },

    handleSelect(index,indexPath){
      this.dateKey=new Date()

      this.$router.push("/home/"+index);
      if(index=="homepage")
      {
        this.IsHomepage=true;
      }
      else
      {
        this.IsHomepage=false;
      }
    },

    goTo(index){
      //直接跳转
      this.$router.push("/home/"+index);
    },
    toggle(){
      this.isCollapse = !this.isCollapse;
      if(this.isCollapse==true){
        this.contentStyle['margin-left'] = "74px";

      }else{
        this.contentStyle['margin-left'] = "200px";
      }
    },
    logOut(){
      this.$cookies.remove("token");
      this.$account.data = null;
      if(this.Isqek){
        this.$router.push("/loginqek");
      }else if(this.isXl){
        this.$router.push("/loginXl");
      }else if(this.islnj){
        this.$router.push("/loginlnj");
      }else {
        this.$router.push("/login");
      }
    },
    changeLang(){
      // 看看当前是中文还是英文
      if(this.currentLang == 'en'){
        this.$i18n.locale = 'en'
      }else{
        this.$i18n.locale = 'zh'
      }
      localStorage.setItem('languageSet',this.$i18n.locale)
    },
    goToLargeScreen(){
      this.$router.push("/largeScreen")
    }

  },
  beforeDestroy() {
    //clearInterval(this.timer);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-footer{
  padding: 0px 15px 25px 25px;;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 60%;
}
/*#box {
  width: 100%;
  height: 20px;

  position: relative;
}
.marquee-box  {
  position: relative;
  width: 100%;
  height: 100%;
  overflow:auto;
  background-color: #f8f8f8;
}
#pWidth{
  width: 100%;
  height: 20px;
  padding: 0;
  margin: 0;
  line-height: 20px;
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  overflow:hidden;
  font-size:15px !important;
  background-color: #f8f8f8;
  color: #fc5454;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}*/
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;color:#b4bed0;
  /*margin: 0 10px;*/width: 100%;
}
a {
  color: #42b983;
}
.top{ width:100%;height:80px;margin:0 auto; }
.top .logo{ display:inline-block;width:30%;margin:10px 0px 0px 10px;float:left;text-align:left; position:absolute;left:70px;}
.top .logo img{width:70%;}

.top .admin{ display:inline-block;float:right;line-height:80px;font-size:18px;color:#fff; overflow:hidden;}
.top .admin span{ display:inline-block;float:left;line-height:80px;font-size:18px;color:#fff;}

.top .admin img{width:40px;height:40px;margin:20px 10px 0px 0px; float:left;}
.top .top_ul{ float:right;margin:0px 20px 0px 0px; z-index:100001;padding:0;}
.top .top_ul li{list-style:none;display:inline;float:left;padding:0;}
.top .top_ul li .shezhi{display:block;float:left;padding:20px 10px 7px 10px;text-align:center;line-height:40px !important;font-family:"微软雅黑";font-size:18px;color:#fff;}
.top .top_ul li a:hover{}

.top .top_ul li .nav_specile{background:#fb8e00;color:#fff;}
.top .nav_more{}
.top .nav_more a:hover{color:#fff;}
.top .nav_more:hover .list_ol{display:block;}
.top .nav_more .list_ol{position:absolute;top:80px;width:110px;background:#35414f;display:none;padding:0px;border-top:none; z-index:100000; }
.top .nav_more .list_ol li a{display:block; text-align:center;width:110px;line-height:2.5;color:#b4bed0;font-size:15px;font-family:"微软雅黑";}
.top .nav_more .list_ol li a:hover{background:#35414f;border-bottom:none;color:#fff;line-height:2.5;}


.el-menu{width:16%;}

.el-menu--collapse{width:74px !important;}


    .el-button:focus, .el-button:hover {
    color: #b4bed0;
    border-color:none !important;
    }

    .el-button {
    display: inline-block;
    line-height:1.8;
    white-space: nowrap;
    cursor: pointer;
    background:none;
    color: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 13px 20px; position:absolute;left:0;
    font-size:30px;
    border-radius:0px!important;
    border:none !important;
    outline-style:none;
    }

    .el-submenu .el-menu-item {
      min-width: 100px;
      background-color: #465f74;
    }

    .footer{
      position:absolute;
      right:0;
      bottom:0;
      left:0;
      height: 25px;
      /* background-color: #fff; */
      color: #777777;
    }
</style>
<style lang="less">
  #home{
    .el-switch{
      height: 80px;
      float: right;
      margin-right: 20px;
    }
    .el-switch__label.is-active{
      color: #fff;
    }
    .el-switch__label{
      color: #fff
    }
    .englishText{
      .el-menu-item{
        font-size: 12px!important;
      }
      .el-submenu__title{
        font-size: 12px!important;
      }
      .xssj_right1 span{
        font-size: 12px!important;
      }
      .sbph_row01{
        font-size: 12px!important;
      }
      .el-col-6{
        padding-left: 0!important;
        padding-right: 0!important;
      }
      .lsxs ul li span{
        font-size: 12px!important;
      }
      .spec-span{
        span{
          line-height: 20px!important;
        }
      }
    }
    .chineseText{
      .el-menu-item{
        font-size: 16px!important;
      }
      .el-submenu__title{
        font-size: 16px!important;
      }
      .xssj_right1 span{
        font-size: 16px!important;
      }
      .spec-span{
        span{
          line-height: 40px!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue